import { LIMIT_30 } from '@anytag/shared-constants';
import { convertOrderToORDER } from '@anytag/shared-utils';
import { InfluencerInstagramAnalyticsPostDetailsModal } from '@anytag/shared-molecules';
import { AnalyticsInstagramDashboardFeedPostsTemplate } from '@anytag/shared-organisms';
import { Order, InstagramFeedPostSortField, useInfluencerAllInstagramFeedPostsQuery } from '@anytag/graphql';
import { PostDetailsType } from '@anytag/shared-types';
import { InfluencerSelectedAccountInfo } from '../../types';

interface InfluencerAnalyticsInstagramProfileFeedPostsProps {
  socialAccount: InfluencerSelectedAccountInfo;
  influencerId: number;
}

export const InfluencerAnalyticsInstagramProfileFeedPosts = ({
  socialAccount: { id: socialAccountId, name },
  influencerId
}: InfluencerAnalyticsInstagramProfileFeedPostsProps) => {
  const { data } = useInfluencerAllInstagramFeedPostsQuery({
    variables: {
      offset: 0,
      limit: LIMIT_30,
      socialAccountId,
      orderBy: { field: InstagramFeedPostSortField.POST_DATE, order: convertOrderToORDER(Order.DESC) }
    }
  });

  const posts = data?.influencerAllInstagramFeedPosts || [];

  return (
    <>
      <AnalyticsInstagramDashboardFeedPostsTemplate
        data={posts}
        moreDetailProps={{
          to: '/influencer/$id/$socialMediaAccountId/instagram_feed_post',
          params: { socialMediaAccountId: socialAccountId.toString(), id: influencerId.toString() },
          search: { filter: { name } }
        }}
      />

      <InfluencerInstagramAnalyticsPostDetailsModal
        posts={posts.map(({ id }): PostDetailsType => ({ id, mainSocialAccountId: socialAccountId }))}
      />
    </>
  );
};
